import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from "@angular/router";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {DashboardPageComponent} from "./pages/dashboard-page/dashboard-page.component";
import {DashboardRoutingModule} from "./dashboard.routing.module";
import {NgChartsModule} from "ng2-charts";
import {BrowserModule} from "@angular/platform-browser";
import {SharedModule} from "../shared-module/shared.module";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatTabsModule} from "@angular/material/tabs";
import {MatIconModule} from "@angular/material/icon";

@NgModule({
  declarations: [
    DashboardPageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    DashboardRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatInputModule,
    NgChartsModule,
    SharedModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatIconModule,
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class DashboardModuleModule {
}
